import { LockOutlined } from '@ant-design/icons';

import { Form, Input } from 'antd';

import messages from 'containers/ResetPage/messages';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import translations from 'translations';
import media from 'utils/mediaStyle';
import utilsMessages from 'utils/messages';
import Button from '../Button/Button';
import PageHeader from '../PageHeader/PageHeader';
import topBg from './top-bg.png';

const Container = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 8pt;
  flex: 1;
  max-width: 720px;
  background-image: url(${topBg});
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 8pt;
  ${media.md`
    padding: 30pt 90pt;
  `};
  p {
    line-height: normal;
  }
`;

const Password = styled(Input.Password)<any>``;

interface ResetFormProps {
  form: any;
  onSubmit: (data: any) => void;
}

const ResetForm: FC<ResetFormProps> = ({ onSubmit }) => {
  const [form] = Form.useForm();

  const checkConfirmPassword = (_: any, value: any) => {
    const password = form.getFieldValue('password');

    if (!value) {
      return Promise.resolve();
    }

    if (password && value !== password) {
      return Promise.reject(translations(messages.confirmPasswordNotCorrect));
    }
    return Promise.resolve();
  };

  const handleSubmit = (values: any) => {
    onSubmit(values);
  };

  return (
    <Container>
      <PageHeader size="large">
        <FormattedMessage {...messages.header} />
      </PageHeader>
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <FormattedMessage {...messages.plsInputPassword}>
          {(requiredMsg: string) => (
            <Form.Item
              name="password"
              colon={false}
              required={false}
              label={translations(messages.password)}
              getValueFromEvent={(e) => e.target.value.trim()}
              rules={[
                { required: true, message: requiredMsg },
                {
                  min: 8,
                  message: translations(messages.passwordLengthError),
                },
                {
                  max: 20,
                  message: translations(messages.passwordLengthError),
                },
              ]}
            >
              <Password
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder={translations(messages.password)}
                autoComplete="new-password"
                size="large"
              />
            </Form.Item>
          )}
        </FormattedMessage>
        <FormattedMessage {...messages.plsInputConfirmPassword}>
          {(requiredMsg: string) => (
            <Form.Item
              name="confirmPassword"
              colon={false}
              required={false}
              label={translations(messages.confirmPassword)}
              dependencies={['password']}
              getValueFromEvent={(e) => e.target.value.trim()}
              rules={[
                {
                  required: true,
                  message: requiredMsg,
                },
                {
                  validator: checkConfirmPassword,
                },
              ]}
            >
              <Password
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder={translations(messages.confirmPassword)}
                autoComplete="off"
                size="large"
              />
            </Form.Item>
          )}
        </FormattedMessage>
        <Form.Item>
          <Button block type="bg-primary" htmlType="submit" size="large">
            <FormattedMessage {...utilsMessages.reset} />
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default ResetForm;
